// Angular
import { Injectable } from '@angular/core';
// Afidium
import {
    IGetBookingsAirResponse,
    IGetBookingsStayResponse,
    ISectorAir,
    ISectorStay,
    TGetBookingResponse
} from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ISummarySectorAir, ISummarySectorStay } from 'libraries/component/booking-information/components/sectors/components/shared/interfaces/ISummary';
import { DateDifferenceService } from 'libraries/service/date/date-difference/date-difference.service';
import { BookingType } from 'libraries/service/resources/booking/interfaces/get-bookings.enum';
import { SectorXType } from '../resources/model/search/air/IAirSector';

@Injectable()
export class SectorService {
    constructor(
        private readonly dateDifferenceService: DateDifferenceService,
    ) {
    }

    public getSectors(booking: TGetBookingResponse): ISummarySectorStay[] | ISummarySectorAir[] {
        const types: BookingType[] = booking.type;

        if (types && types.includes(BookingType.stay) && (booking as IGetBookingsStayResponse | IGetBookingsAirResponse).sector) {
            return getStaySectors(booking as IGetBookingsStayResponse);
        }

        return this.getAirSectors(booking as IGetBookingsAirResponse);
    }

    private getAirSectors(booking: IGetBookingsAirResponse): ISummarySectorAir[] {
        const sector: ISectorAir[] = booking.sector.filter((sectorAir: ISectorAir) => sectorAir.xType === SectorXType.air);
        const sectorLength: number = sector.length;

        return sector
            .map((sectorAir: ISectorAir, index: number): ISummarySectorAir => {
                let mappedSector: ISummarySectorAir = {
                    ...sectorAir,
                    host: booking.host,
                    code: booking.code,
                };

                if (sectorLength > 0 && sectorLength > (index + 1)) {
                    mappedSector = {
                        ...mappedSector,
                        time: this.dateDifferenceService.getDiffText(sector[index + 1].begin, sectorAir.end),
                    };
                }

                return mappedSector;
            });
    }
}

function getStaySectors(booking: IGetBookingsStayResponse): ISummarySectorStay[] {
    return (booking.sector || []).map((sector: ISectorStay): ISummarySectorStay => {
        return {
            ...sector,
            host: booking.host,
            code: booking.code,
        };
    });
}